export default __webpack_public_path__ + "static/media/Soulguard.5c841cd7.jpg";